import InviraRolesManagementPage from './index.vue'
export {InviraRolesManagementPage}
export default InviraRolesManagementPage

